import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Row, H4, Copy, Label, FormField, Box, Button } from '@honda-canada/design-system-react';
import themeStyles from './styles/Search.styles';

const CopyContainer = themeStyles.apply(Box, 'CopyContainer');
const FormContainer = themeStyles.apply(Box, 'FormContainer');
const SearchButton = themeStyles.apply(Button, 'SearchButton');

const Search = ({ hasError, inputProps, adornmentProps, handleSubmit, onKeyDown, dataTestId, asteriskColor }) => {
  const { t } = useTranslation();

  return (
    <Row flexDirection="column" alignItems="center" alignContent="center">
      <Box textAlign="center" mb={4}>
        <H4 fontWeight="normal" lineHeight={['default', 'default', 'l']}>
          {t('Sub-apps.Recalls.lookupVinStatusLabel')}
        </H4>
      </Box>
      <CopyContainer lineHeight={['22px', '22px', '26px']}>
        <Copy fontSize={['14px', '14px', '16px']}>{t('Sub-apps.Recalls.toCheckRecallsAndUpdatesText')}</Copy>
      </CopyContainer>
      <FormContainer mb={6} data-testid={dataTestId}>
        <Label display="flex" fontFamily="bold">
          {t('Sub-apps.Recalls.enterYourVinLabel')}
          <Copy color={asteriskColor}>*</Copy>
        </Label>
        <FormField
          lineHeight="default"
          hasError={hasError}
          input={inputProps}
          defaultAdornmentProps={adornmentProps}
          clearIconAriaLabel={t('clearIconAriaLabel')}
          style={{ backgroundColor: 'white' }}
          onKeyDown={onKeyDown}
        />
        {hasError && (
          <Label mt={3} hasError>
            {t('Sub-apps.Recalls.invalidVinFormatLabel')}
          </Label>
        )}
      </FormContainer>
      <SearchButton
        styling="primary"
        onClick={handleSubmit}
        data-testid="cy-search-button"
        disabled={!inputProps.value}
      >
        {t('Sub-apps.Recalls.searchVinButton')}
      </SearchButton>
    </Row>
  );
};

Search.propTypes = {
  inputProps: PropTypes.shape({
    value: PropTypes.string,
  }),
  adornmentProps: PropTypes.shape({}),
  handleSubmit: PropTypes.func,
  onKeyDown: PropTypes.func,
  hasError: PropTypes.bool,
  dataTestId: PropTypes.string,
  asteriskColor: PropTypes.string,
};

export default Search;
